export class DispatchEmployeeJobsDTO {
  jobId: string;
  jobName: string;
  startDate: Date;
  endDate: Date;
  dispatchStatus: string;
  employeeId: string;
}
